import { Check, X } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { COMPARISON } from "@/lib/site-data";

export default function Comparison() {
  return (
    <section className="relative py-24 sm:py-32 bg-[#F5F5F7] border-y border-black/5">
      <div className="mx-auto max-w-[1000px] px-5 sm:px-8">
        <Reveal>
          <div className="mb-4 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.22em] text-[#E31B23]">
            <span className="h-px w-8 bg-[#E31B23]" /> The difference
          </div>
          <h2 className="max-w-2xl font-display text-4xl font-extrabold leading-tight text-[#1F1F1F] sm:text-5xl">
            Why shippers switch to us.
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-12 overflow-hidden rounded-3xl border border-black/5 bg-white shadow-[0_20px_50px_-30px_rgba(17,24,39,0.4)]" data-testid="comparison-table">
            <div className="grid grid-cols-[1.4fr_1fr_1fr]">
              <div className="p-5 sm:p-6" />
              <div className="p-5 sm:p-6 text-center bg-[#5A189A] text-white">
                <div className="font-display text-lg font-extrabold">XPRESSNGOSHIP</div>
              </div>
              <div className="p-5 sm:p-6 text-center">
                <div className="font-display text-lg font-bold text-[#9ca3af]">Others</div>
              </div>

              {COMPARISON.map((row, i) => (
                <div key={i} className="contents">
                  <div className={`p-5 sm:p-6 text-sm font-medium text-[#1F1F1F] ${i % 2 ? "bg-[#F5F5F7]" : ""}`}>{row.label}</div>
                  <div className={`flex items-center justify-center p-5 sm:p-6 bg-[#5A189A]/[0.05] ${i % 2 ? "bg-[#5A189A]/[0.08]" : ""}`}>
                    <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#5A189A]"><Check size={16} className="text-white" /></span>
                  </div>
                  <div className={`flex flex-col items-center justify-center gap-1 p-5 sm:p-6 ${i % 2 ? "bg-[#F5F5F7]" : ""}`}>
                    <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#E31B23]/10"><X size={16} className="text-[#E31B23]" /></span>
                    <span className="text-[11px] text-[#9ca3af]">{row.themNote}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
